import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { useCallback } from "react";
import { ProductRootPartialScreen } from "../../../products/screens/ProductRootPartialScreen";
import {
  BarcodeScannerScreen,
  BarcodeSettingsScreen,
  ScanAgainScreen,
} from "./screens";

export interface BarcodeScannerRootScreenProps {
  onScanSuccess: (productId: string) => void;
}

export function BarcodeScannerRootScreen({
  onScanSuccess,
}: BarcodeScannerRootScreenProps) {
  const Stack = createStackHeaderNavigator();

  const BarcodeScannerScreenConfigured = useCallback(() => {
    return <BarcodeScannerScreen onScanSuccess={onScanSuccess} />;
  }, []);

  return (
    <Stack.Navigator
      detachInactiveScreens
      screenOptions={{
        headerShown: false,
        headerTitleAlign: "center",
        cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
      }}
    >
      <Stack.Screen
        name="BarcodeScannerScreen"
        component={BarcodeScannerScreenConfigured}
      />
      <Stack.Group
        screenOptions={{
          presentation: "modal",
          cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
        }}
      >
        <Stack.Screen
          name="BarcodeSettingsScreen"
          options={{
            title: "Scanner Settings",
            headerShown: true,
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Close" iconOnly />,
          }}
          component={BarcodeSettingsScreen}
        />
      </Stack.Group>
      <Stack.Group
        screenOptions={{
          presentation: "transparentModal",
          cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
        }}
      >
        <Stack.Screen
          name="ScanAgainScreen"
          options={{
            headerShown: false,
            animationEnabled: true,
          }}
          component={ScanAgainScreen}
        />
        <Stack.Screen
          name="ProductRootPartialScreen"
          options={{
            headerShown: false,
            animationEnabled: true,
          }}
          component={ProductRootPartialScreen}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
}
